import { Preferences } from '@capacitor/preferences'

let memoryAccessToken: string | null = null

export const appAuth = {
  async setTokens(tokens: {
    access_token: string
    refresh_token?: string
  }) {
    memoryAccessToken = tokens.access_token

    await Preferences.set({
      key: 'access_token',
      value: tokens.access_token
    })

    if (tokens.refresh_token) {
      await Preferences.set({
        key: 'refresh_token',
        value: tokens.refresh_token
      })
    }
  },

  async getAccessToken() {
    if (memoryAccessToken) {
      return memoryAccessToken
    }

    const { value } =
      await Preferences.get({ key: 'access_token' })

    memoryAccessToken = value
    return value
  },

  async setUser(user: any) {
    await Preferences.set({
      key: 'user_profile',
      value: JSON.stringify(user)
    })
  },

  async getUser() {
    const { value } = await Preferences.get({ key: 'user_profile' })
    if (value) {
      try {
        return JSON.parse(value)
      } catch {
        return null
      }
    }
    return null
  },

  async clear() {
    memoryAccessToken = null

    await Preferences.remove({ key: 'access_token' })
    await Preferences.remove({ key: 'refresh_token' })
    await Preferences.remove({ key: 'user_profile' })
  },

  async checkAuth() {
    const token = await this.getAccessToken()
    return !!token
  },

  async login() {
    // 你原本 login flow
  },

  async logout() {
    await this.clear()
  }
}